import ChartWidget from './chart-widget.component';
export default ChartWidget;
